export default __webpack_public_path__ + "static/media/footer_welcome_startup.15e447fe.svg";